import { gql } from '@apollo/client';
import { issue_fields } from './issues';
import {
    FR_SERVICE_RECURRENT_METER_TYPE,
    FR_SERVICE_PRIORITY_CLASS_FIELDS,
    FR_SERVICE_TASK_FIELDS,
    FR_SERVICE_WORK_FIELDS,
    FR_SERVICE_SCHEDULE,
    FR_SERVICE_RECURRENT_TYPE,
    FR_SERVICE_ENTRY_FIELDS,
    FR_SERVICE_PROGRAM_FIELDS,
    FR_SERVICE_WORK_FIELDS_WITH_TASK,
    FR_SERVICE_ISSUE_FIELDS
} from './fragments/service';
import { FR_CATEGORY_FIELDS } from './fragments/category';
import { FR_COMPONENT_FIELDS } from './fragments/component';
import { FR_ASSEMBLY_FIELDS } from './fragments/assembly';

const serviceTask_fields = `
	ServiceTaskId
  	Name
	ServiceWork {
		Name
		ServiceWorkId
	}
	sv_name: Name(LangCode: SV)
  	en_name: Name(LangCode: EN)
	no_name: Name(LangCode: NO)
  	Description
	sv_description: Description(LangCode: SV)
	en_description: Description(LangCode: EN)
	no_description: Description(LangCode: NO)
	Created
	Updated
	Access {  
		Read
		Create
		Delete
		Update
	}
	OrganizationAccess {
		Organization {
			OrganizationId
			Name
		}
		OrganizationAccessType {
			__typename
			... on ServiceTaskOrganizationType {
				ServiceTaskOrganizationTypeId
				Name
			}
		}
	}
`;

const serviceWork_fields = `
    ServiceWorkId
	Name
	sv_name: Name(LangCode: SV)
    en_name: Name(LangCode: EN)
	no_name: Name(LangCode: NO)
    Description
	sv_description: Description(LangCode: SV)
	en_description: Description(LangCode: EN)
	no_description: Description(LangCode: NO)
    ServiceTask{
		ServiceTaskId
		Name
		sv_name: Name(LangCode: SV)
		en_name: Name(LangCode: EN)
		no_name: Name(LangCode: NO)
    }
    Created
    Updated
`;

export const recurrentType_fields = `
	RecurrentTypeId
	Name
`;

export const recurrentMeterType_fields = `
	RecurrentMeterTypeId
	Name
`;

const ServicePriorityClass_fields = `
	ServicePriorityClassId
	Name
`;
export const serviceAgreement_fields = `
	ServiceAgreementId
	StartDate
	EndDate
	Machine {
		__typename
		MachineId
		Name
		SerialNbr
		MachineType {
			Name
			MachineTypeId
		}
	}
	ServiceProgram{
		ServiceProgramId
		Name
		sv_name: Name(LangCode: SV)
   		en_name: Name(LangCode: EN)
	}
`;

const serviceSchedule_fields = `
  ServiceScheduleId
	Name
	sv_name: Name(LangCode: SV)
	en_name: Name(LangCode: EN)
	no_name: Name(LangCode: NO)
  Description
	sv_description: Description(LangCode: SV)
	en_description: Description(LangCode: EN)
	no_description: Description(LangCode: NO)
	ServiceItems {
		ServiceItemId
		ServiceTask {
			ServiceTaskId
		}
		ServiceWork {
			ServiceWorkId
		}
	}
	ServiceEntry {
		ServiceEntryId
		ServiceEntryTask{
			ServiceEntryTaskId
		}
	}
	RecurrentCycle
	SecondaryRecurrentCycle
	RecurrentType{
		${recurrentType_fields}
	}
	SecondaryRecurrentType{
		${recurrentType_fields}
	}
	SecondaryRecurrentMeterType{
		${recurrentMeterType_fields}
	}
	RecurrentMeterType{
		${recurrentMeterType_fields}
	}
    Created
    Updated
	Access {  
		Read
		Create
		Delete
		Update
	}
	OrganizationAccess {
		Organization {
			OrganizationId
			Name
		}
		OrganizationAccessType {
			__typename
			... on ServiceScheduleOrganizationType {
				ServiceScheduleOrganizationTypeId
				Name
			}
		}
	}
`;

const serviceProgram_fields = `
    ServiceProgramId
	Name
	sv_Name: Name(LangCode: SV)
	en_Name: Name(LangCode: EN)
	no_Name: Name(LangCode: NO)
    Description
	sv_Description: Description(LangCode: SV)
	en_Description: Description(LangCode: EN)
	no_Description: Description(LangCode: NO)
	ServiceSchedule{
		ServiceScheduleId
		Name
		sv_Name: Name(LangCode: SV)
		en_Name: Name(LangCode: EN)
		no_Name: Name(LangCode: NO)
		ServiceItems {
			ServiceItemId
		}
	}
	ServiceAgreement{
		${serviceAgreement_fields}
	}
	RecurrentMeterType{
		${recurrentMeterType_fields}
	}
	SecondaryRecurrentMeterType{
		${recurrentMeterType_fields}
	}
    Created
    Updated
	Access {  
		Read
		Create
		Delete
		Update
	}
	OrganizationAccess {
		Organization {
			OrganizationId
			Name
		}
		OrganizationAccessType {
			__typename
			... on ServiceProgramOrganizationType {
				ServiceProgramOrganizationTypeId
				Name
			}
		}
	}
`;

const serviceEntry_fields = `
	ServiceEntryId
	Name
    Description
	ServiceDate
	OperatingHours
	ServicePriorityClass{
		${ServicePriorityClass_fields}
	}
	RecurrentMeterType{
		${recurrentMeterType_fields}
	}
	ServiceEntryStatus{
		Name
	}
	ServiceEntryTask {
		ServiceEntryTaskId
		ServiceTime
		Description
		ServiceItems {
			ServiceItemId
			ServiceWork {
				ServiceWorkId
				Name
				sv_name: Name(LangCode: SV)
				en_name: Name(LangCode: EN)
				no_name: Name(LangCode: NO)
				Description
				sv_description: Description(LangCode: SV)
				en_description: Description(LangCode: EN)
				no_description: Description(LangCode: NO)
			}
			ServiceEntryTaskStatus{
				Name
			}
			ServiceTask {
				Name
				sv_name: Name(LangCode: SV)
				en_name: Name(LangCode: EN)
				no_name: Name(LangCode: NO)
				Description
				sv_description: Description(LangCode: SV)
				en_description: Description(LangCode: EN)
				no_description: Description(LangCode: NO)
			ServiceTaskId
			ServiceWork {
					ServiceWorkId
			}
			}
			Issue{
				${issue_fields}
			}
		}
	}
	ServiceEntryOrderer {
    Firstname
		Lastname
		UserId
	}
	ServiceEntryCompleter{
    Firstname
		Lastname
		UserId
	}
	Completed
	CompletedDate
	ServiceSchedule{
		ServiceScheduleId
		ServiceItems {
			ServiceItemId
			ServiceTask {
				ServiceTaskId
			}
			ServiceWork {
				ServiceWorkId
			}
		}
	}
	ServiceVendor{
		OrganizationId
		Name
	}
	Issues {
		IssueId
		IssueStatus {
			IssueStatusId
			Name
		}

	}
	Machine {
		MachineId
		Name
		SerialNbr
		Organization {
			OrganizationId
			Name
		}
		MachineType {
			Name
			MachineTypeId
		}
		Asset {
			AssetName
			AssetType
		  }
	}
    Created
    Updated
`;

/* ----------------------- enums ---------------------------------------  */

export const GET_RECURRENT_TYPES = gql`
    query recurrentTypes {
        recurrentTypes {
            ...fr_ServiceRecurrentTypeFields
        }
    }
    ${FR_SERVICE_RECURRENT_TYPE}
`;

export const GET_RECURRENTMETER_TYPES = gql`
    query recurrentMeterTypes {
        recurrentMeterTypes {
            ...fr_ServiceRecurrentMeterTypeFields
        }
    }
    ${FR_SERVICE_RECURRENT_METER_TYPE}
`;

export const GET_SERVICEPRIORITY_CLASSES = gql`
    query ServicePriorityClass {
        ServicePriorityClass {
            ...fr_ServicePriorityClassFields
        }
    }
    ${FR_SERVICE_PRIORITY_CLASS_FIELDS}
`;

/* ----------------------- serviceTask ---------------------------------------  */

export const GET_SERVICE_TASKS = gql`
    query serviceTasks {
        serviceTasks {
            ...fr_ServiceTaskFields
        }
    }
    ${FR_SERVICE_TASK_FIELDS}
`;

export const CREATE_SERVICE_TASK = gql`
    mutation createServiceTask(
        $Name: [LangCodeTextInputType!]!
        $Description: [LangCodeTextInputType!]!
        $ServiceItem: ServiceItemInputType
        $AddOrganizations: [Int!]
    ) {
        createServiceTask(
            data: {
                Name: $Name
                Description: $Description
                AddOrganizations: $AddOrganizations
                ServiceItem: $ServiceItem
            }
        ) {
            ...fr_ServiceTaskFields
        }
    }
    ${FR_SERVICE_TASK_FIELDS}
`;

export const UPDATE_SERVICE_TASK = gql`
    mutation updateServiceTask(
        $ServiceTaskId: Int!
        $Name: [LangCodeTextInputType!]
        $Description: [LangCodeTextInputType!]
        $ServiceItem: ServiceItemInputType
        $AddOrganization: [Int!]
        $RemoveOrganization: [Int!]
    ) {
        updateServiceTask(
            data: {
                ServiceTaskId: $ServiceTaskId
                Name: $Name
                Description: $Description
                AddOrganization: $AddOrganization
                RemoveOrganization: $RemoveOrganization
                ServiceItem: $ServiceItem
            }
        ) {
            ...fr_ServiceTaskFields
        }
    }
    ${FR_SERVICE_TASK_FIELDS}
`;

export const DELETE_SERVICE_TASK = gql`
    mutation deleteServiceTask($ServiceTaskId: Int!) {
        deleteServiceTask(data: { ServiceTaskId: $ServiceTaskId })
    }
`;

/* ----------------------- ServiceWork ---------------------------------------  */

export const GET_SERVICE_WORKS = gql`
    query ServiceWorks {
        ServiceWorks {
            ...fr_ServiceWorkFields
        }
    }
    ${FR_SERVICE_WORK_FIELDS}
`;

export const GET_SERVICE_WORKS_WITH_TASK = gql`
    query ServiceWorks {
        ServiceWorks {
            ...fr_ServiceWorkFieldsWithTask
        }
    }
    ${FR_SERVICE_WORK_FIELDS_WITH_TASK}
`;

export const CREATE_SERVICE_WORK = gql`
    mutation createServiceWork(
        $Name: [LangCodeTextInputType!]!
        $Description: [LangCodeTextInputType!]!
        $CreateServiceTasks: [CreateServiceTaskInputType!]
        $AddServiceTasks: [Int!]
    ) {
        createServiceWork(
            data: {
                Name: $Name
                Description: $Description
                CreateServiceTasks: $CreateServiceTasks
                AddServiceTasks: $AddServiceTasks
            }
        ) {
            ...fr_ServiceWorkFieldsWithTask
        }
    }
    ${FR_SERVICE_WORK_FIELDS_WITH_TASK}
`;

export const UPDATE_SERVICE_WORK = gql`
    mutation updateServiceWork(
        $ServiceWorkId: Int!
        $Name: [LangCodeTextInputType!]
        $Description: [LangCodeTextInputType!]
        $CreateServiceTasks: [CreateServiceTaskInputType!]
        $AddServiceTasks: [Int!]
        $RemoveServiceTasks: [Int!]
    ) {
        updateServiceWork(
            data: {
                ServiceWorkId: $ServiceWorkId
                Name: $Name
                Description: $Description
                CreateServiceTasks: $CreateServiceTasks
                AddServiceTasks: $AddServiceTasks
                RemoveServiceTasks: $RemoveServiceTasks
            }
        ) {
            ...fr_ServiceWorkFieldsWithTask
        }
    }
    ${FR_SERVICE_WORK_FIELDS_WITH_TASK}
`;

export const DELETE_SERVICE_WORK = gql`
    mutation deleteServiceWork($ServiceWorkId: Int!) {
        deleteServiceWork(data: { ServiceWorkId: $ServiceWorkId })
    }
`;

/* ----------------------- serviceSchedule ---------------------------------------  */

export const GET_SERVICE_SCHEDULES = gql`
    query serviceSchedules(
        $ServiceScheduleId: Int
        $Connected: ServiceScheduleFilterEnum
        $MachineId: Int
    ) {
        serviceSchedules(
            data: {
                Connected: $Connected
                ServiceScheduleId: $ServiceScheduleId
                MachineId: $MachineId
            }
        ) {
            ...fr_ServiceScheduleFields
        }
    }
    ${FR_SERVICE_SCHEDULE}
`;

export const CREATE_SERVICE_SCHEDULE = gql`
    mutation createServiceSchedule(
        $Name: [LangCodeTextInputType!]!
        $Description: [LangCodeTextInputType!]!
        $AddServiceItems: [ServiceScheduleAddServiceItems!]
        $RecurrentType: RecurrentTypeEnum
        $SecondaryRecurrentType: RecurrentTypeEnum
        $RecurrentCycle: Int
        $SecondaryRecurrentCycle: Int
        $AddOrganizations: [Int!]
    ) {
        createServiceSchedule(
            data: {
                Name: $Name
                Description: $Description
                AddServiceItems: $AddServiceItems
                RecurrentType: $RecurrentType
                SecondaryRecurrentType: $SecondaryRecurrentType
                RecurrentCycle: $RecurrentCycle
                SecondaryRecurrentCycle: $SecondaryRecurrentCycle
                AddOrganizations: $AddOrganizations
            }
        ) {
            ...fr_ServiceScheduleFields
        }
    }
    ${FR_SERVICE_SCHEDULE}
`;

export const UPDATE_SERVICE_SCHEDULE = gql`
    mutation updateServiceSchedule(
        $ServiceScheduleId: Int!
        $Name: [LangCodeTextInputType!]
        $Description: [LangCodeTextInputType!]
        $RecurrentType: RecurrentTypeEnum
        $SecondaryRecurrentType: RecurrentTypeEnum
        $RecurrentCycle: Int
        $SecondaryRecurrentCycle: Int
        $UpsertServiceItems: [UpdateServiceScheduleUpsertServiceItem!]
        $RemoveServiceItems: [Int!]
        $AddOrganizations: [Int!]
        $RemoveOrganizations: [Int!]
    ) {
        updateServiceSchedule(
            data: {
                ServiceScheduleId: $ServiceScheduleId
                Name: $Name
                Description: $Description
                RecurrentType: $RecurrentType
                SecondaryRecurrentType: $SecondaryRecurrentType
                RecurrentCycle: $RecurrentCycle
                SecondaryRecurrentCycle: $SecondaryRecurrentCycle
                UpsertServiceItems: $UpsertServiceItems
                RemoveServiceItems: $RemoveServiceItems
                AddOrganizations: $AddOrganizations
                RemoveOrganizations: $RemoveOrganizations
            }
        ) {
            ...fr_ServiceScheduleFields
        }
    }
    ${FR_SERVICE_SCHEDULE}
`;

export const DELETE_SERVICE_SCHEDULE = gql`
    mutation deleteServiceSchedule($ServiceScheduleId: Int!) {
        deleteServiceSchedule(data: { ServiceScheduleId: $ServiceScheduleId })
    }
`;

/* ----------------------- serviceProgram ---------------------------------------  */

export const GET_SERVICE_PROGRAMS = gql`
    query servicePrograms {
        servicePrograms {
            ...fr_ServiceProgramFields
        }
    }
    ${FR_SERVICE_PROGRAM_FIELDS}
`;

export const CREATE_SERVICE_PROGRAM = gql`
mutation createServiceProgram(
	$Name: [LangCodeTextInputType!]!
	$Description: [LangCodeTextInputType!]!
	$CreateServiceSchedules: [CreateServiceScheduleInputType!]
	$CreateServiceAgreement: [ServiceProgramCreateServiceAgreementInputType!]
	$RecurrentMeterType: RecurrentMeterTypeEnum
	$SecondaryRecurrentMeterType: RecurrentMeterTypeEnum
	$AddOrganizations: [Int!]

) {
	createServiceProgram(
		data:{
			Name: $Name
			Description: $Description
			CreateServiceSchedules: $CreateServiceSchedules
			RecurrentMeterType: $RecurrentMeterType
			SecondaryRecurrentMeterType: $SecondaryRecurrentMeterType
			CreateServiceAgreement: $CreateServiceAgreement
			AddOrganizations: $AddOrganizations
		}
	) {
		${serviceProgram_fields}
	}
}`;

export const UPDATE_SERVICE_PROGRAM = gql`
mutation updateServiceProgram(
  $ServiceProgramId:Int!
	$Name: [LangCodeTextInputType!]
	$Description: [LangCodeTextInputType!]
	$RecurrentMeterType: RecurrentMeterTypeEnum
	$SecondaryRecurrentMeterType: RecurrentMeterTypeEnum
	$AddServiceSchedule: [Int!]
	$RemoveServiceSchedule: [Int!]
	$CreateServiceSchedules: [CreateServiceScheduleInputType!]
	$CreateServiceAgreement: [ServiceProgramCreateServiceAgreementInputType!]
	$RemoveServiceAgreement: [RemoveServiceAgreementInputType!]
	$UpdateServiceAgreement: [UpdateServiceAgreementInputType!]
	$NewOwnerOrganizationId: Int
	$AddOrganizations: [Int!]
	$RemoveOrganizations: [Int!]
) {
	updateServiceProgram(
		data:{
      ServiceProgramId: $ServiceProgramId
			Name: $Name
			Description: $Description
			RecurrentMeterType: $RecurrentMeterType
			SecondaryRecurrentMeterType: $SecondaryRecurrentMeterType
			AddServiceSchedule: $AddServiceSchedule
			RemoveServiceSchedule: $RemoveServiceSchedule
			CreateServiceSchedules: $CreateServiceSchedules
			CreateServiceAgreement: $CreateServiceAgreement
			RemoveServiceAgreement: $RemoveServiceAgreement
			UpdateServiceAgreement: $UpdateServiceAgreement
			AddOrganizations: $AddOrganizations
			RemoveOrganizations: $RemoveOrganizations
			NewOwnerOrganizationId: $NewOwnerOrganizationId
		}
	) {
		${serviceProgram_fields}
	}
}`;

export const DELETE_SERVICE_PROGRAM = gql`
    mutation deleteServiceProgram($ServiceProgramId: Int!) {
        deleteServiceProgram(data: { ServiceProgramId: $ServiceProgramId })
    }
`;

/* ----------------------- serviceEntry ---------------------------------------  */

/*export const GET_SERVICE_ENTRIES = gql`
query serviceEntry($MachineId: Int, $ServiceEntryId: Int, $ServiceTaskId: Int) { 
	serviceEntry(data: {MachineId: $MachineId, ServiceEntryId: $ServiceEntryId, ServiceTaskId: $ServiceTaskId}){
		${serviceEntry_fields}
	}
}`;*/

export const GET_SERVICE_PARTNER_STATUS = gql`
    query getServicePartnerStatus($StartDate: Date!, $EndDate: Date!) {
        partnerStatus(data: { StartDate: $StartDate, EndDate: $EndDate }) {
            Date
            Partner {
                Name
            }
            MachineCount
        }
    }
`;

export const GET_SERVICE_ENTRY_ROWS = gql`
    query GetServiceEntryRows(
        $MachineId: Int
        $ServiceEntryId: [Int!]
        $ServiceItemId: Int
        $ServiceDateStart: Date
        $ServiceDateEnd: Date
        $Status: [ServiceEntryStatusEnum!]
        $From: Int
        $To: Int
        $TextSearch: String
    ) {
        serviceEntryRows(
            data: {
                MachineId: $MachineId
                ServiceEntryId: $ServiceEntryId
                ServiceItemId: $ServiceItemId
                ServiceDateStart: $ServiceDateStart
                ServiceDateEnd: $ServiceDateEnd
                Status: $Status
                From: $From
                To: $To
                TextSearch: $TextSearch
            }
        ) {
            TotalRowCount
            ServiceEntry {
                ...fr_ServiceEntryFields
            }
        }
    }
    ${FR_SERVICE_ENTRY_FIELDS}
`;

export const GET_SERVICE_ENTRY_AUTOCOMPLETE_ROWS = gql`
    query GetServiceEntryAutoCompleteRows(
        $MachineId: Int
        $ServiceEntryId: [Int!]
        $ServiceItemId: Int
        $ServiceDateStart: Date
        $ServiceDateEnd: Date
        $Status: [ServiceEntryStatusEnum!]
        $From: Int
        $To: Int
        $TextSearch: String
    ) {
        serviceEntryAutoCompleteRows(
            data: {
                MachineId: $MachineId
                ServiceEntryId: $ServiceEntryId
                ServiceItemId: $ServiceItemId
                ServiceDateStart: $ServiceDateStart
                ServiceDateEnd: $ServiceDateEnd
                Status: $Status
                From: $From
                To: $To
                TextSearch: $TextSearch
            }
        ) {
            TotalRowCount
            ServiceEntry {
                ...fr_ServiceEntryFields
            }
        }
    }
    ${FR_SERVICE_ENTRY_FIELDS}
`;

export const GET_SERVICE_ENTRIES = gql`
    query serviceEntry(
        $MachineId: Int
        $ServiceEntryId: [Int!]
        $ServiceItemId: Int
        $ServiceDateStart: Date
        $ServiceDateEnd: Date
        $Status: [ServiceEntryStatusEnum!]
        $From: Int
        $To: Int
    ) {
        serviceEntry(
            data: {
                MachineId: $MachineId
                ServiceEntryId: $ServiceEntryId
                ServiceItemId: $ServiceItemId
                ServiceDateStart: $ServiceDateStart
                ServiceDateEnd: $ServiceDateEnd
                Status: $Status
                From: $From
                To: $To
            }
        ) {
            ...fr_ServiceEntryFields
        }
    }
    ${FR_SERVICE_ENTRY_FIELDS}
`;

export const CREATE_SERVICE_ENTRY = gql`
    mutation createServiceEntry(
        $MachineId: Int!
        $Name: String!
        $AddServiceItems: [CreateServiceEntryAddServiceItem!]
        $ServicePriorityClass: ServicePriorityClassEnum!
        $ServiceScheduleId: Int
        $Description: String
        $IssueIds: [Int!]
        $OperatingHours: Int
        $ServiceDate: Date
        $ServiceVendorId: Int
        $ServiceEntryOrdererId: Int!
        $EstimateCost: Float
        $ActualCost: Float
        $OrderNbr: String
        $DesiredServiceDate: Date
        $CustomerReferenceNumber: String
    ) {
        createServiceEntry(
            data: {
                MachineId: $MachineId
                Name: $Name
                ServiceScheduleId: $ServiceScheduleId
                Description: $Description
                AddServiceItems: $AddServiceItems
                IssueIds: $IssueIds
                OperatingHours: $OperatingHours
                ServicePriorityClass: $ServicePriorityClass
                ServiceDate: $ServiceDate
                ServiceVendorId: $ServiceVendorId
                ServiceEntryOrdererId: $ServiceEntryOrdererId
                EstimateCost: $EstimateCost
                ActualCost: $ActualCost
                OrderNbr: $OrderNbr
                DesiredServiceDate: $DesiredServiceDate
                CustomerReferenceNumber: $CustomerReferenceNumber
            }
        ) {
            ...fr_ServiceEntryFields
        }
    }
    ${FR_SERVICE_ENTRY_FIELDS}
`;

export const UPDATE_SERVICE_ENTRY = gql`
    mutation updateServiceEntry(
        $ServiceEntryId: Int!
        $Description: String
        $Name: String
        $AddServiceEntryTasks: [AddServiceEntryTasksInputType!]
        $RemoveServiceEntryTasks: [RemoveServiceEntryTasksInputType!]
        $AddIssues: [Int!]
        $RemoveIssues: [Int!]
        $ServiceEntryStatus: ServiceEntryStatusEnum
        $UpdateServiceEntryTasks: [UpdateServiceEntryTasksInputType!]
        $ServicePriorityClass: ServicePriorityClassEnum
        $OperatingHours: Int
        $ServiceDate: Date
        $ServiceVendorId: Int
        $ServiceEntryOrdererId: Int
        $ServiceEntryCompleterId: Int
        $Completed: Boolean
        $EstimateCost: Float
        $ActualCost: Float
        $OrderNbr: String
        $DesiredServiceDate: Date
        $ServiceScheduleId: Int
        $CustomerReferenceNumber: String
    ) {
        updateServiceEntry(
            data: {
                ServiceEntryId: $ServiceEntryId
                Description: $Description
                Name: $Name
                AddServiceEntryTasks: $AddServiceEntryTasks
                RemoveServiceEntryTasks: $RemoveServiceEntryTasks
                AddIssues: $AddIssues
                RemoveIssues: $RemoveIssues
                ServiceEntryStatus: $ServiceEntryStatus
                UpdateServiceEntryTasks: $UpdateServiceEntryTasks
                OperatingHours: $OperatingHours
                ServicePriorityClass: $ServicePriorityClass
                ServiceDate: $ServiceDate
                ServiceVendorId: $ServiceVendorId
                ServiceEntryOrdererId: $ServiceEntryOrdererId
                ServiceEntryCompleterId: $ServiceEntryCompleterId
                Completed: $Completed
                EstimateCost: $EstimateCost
                ActualCost: $ActualCost
                OrderNbr: $OrderNbr
                DesiredServiceDate: $DesiredServiceDate
                ServiceScheduleId: $ServiceScheduleId
                CustomerReferenceNumber: $CustomerReferenceNumber
            }
        ) {
            ...fr_ServiceEntryFields
        }
    }
    ${FR_SERVICE_ENTRY_FIELDS}
`;

export const DELETE_SERVICE_ENTRY = gql`
    mutation deleteServiceEntry($ServiceEntryId: Int!) {
        deleteServiceEntry(data: { ServiceEntryId: $ServiceEntryId })
    }
`;

export const UPDATE_SERVICE_ENTRY_ADD_ISSUES = gql`
mutation updateServiceEntry(
    $ServiceEntryId:Int!
	$AddIssues: [Int!]
) {
	updateServiceEntry(
		data:{
			ServiceEntryId: $ServiceEntryId
			AddIssues: $AddIssues
		}
	) {
		${serviceEntry_fields}
	}
}`;

export const UPDATE_SERVICE_ENTRY_CREATE_ISSUE = gql`
    mutation UpdateServiceEntryCreateIssue(
        $Description: String!
        $Summary: String!
        $MachineId: Int
    ) {
        createIssue(data: { Summary: $Summary, Description: $Description, MachineId: $MachineId }) {
            ...fr_ServiceIssueFields
        }
    }
    ${FR_SERVICE_ISSUE_FIELDS}
`;

export const GET_SERVICE_ITEMS = gql`
    query serviceItems($ServiceTaskId: Int, $ServiceWorkId: Int) {
        serviceItems(data: { ServiceTaskId: $ServiceTaskId, ServiceWorkId: $ServiceWorkId }) {
            ServiceItemId
            ServiceTask {
                ...fr_ServiceTaskFields
            }
            Category {
                ...fr_CategoryFields
            }
            ServiceWork {
                ...fr_ServiceWorkFields
            }
            Assembly {
                ...fr_AssemblyFields
            }
            Component {
                ...fr_ComponentFields
            }
            Access {
                Read
                Create
                Delete
                Update
            }
        }
    }
    ${FR_SERVICE_TASK_FIELDS}
    ${FR_CATEGORY_FIELDS}
    ${FR_COMPONENT_FIELDS}
    ${FR_ASSEMBLY_FIELDS}
    ${FR_SERVICE_WORK_FIELDS}
`;

export const GET_SERVICE_PROGRAM_ROWS = gql`
    query serviceProgramRows($TextSearch: TextSearchInputType, $From: Int, $To: Int) {
        serviceProgramRows(data: { TextSearch: $TextSearch, From: $From, To: $To }) {
            TotalRowCount
            ServiceProgram {
                ...fr_ServiceProgramFields
            }
        }
    }
    ${FR_SERVICE_PROGRAM_FIELDS}
`;
